/**
 * What: Defines Shopify sync-status product language.
 * Transport / data-flow: Pure TypeScript constants consumed by `productLanguageShopify`.
 *
 */
export const shopifySyncLanguage = {
    title: 'Shopify data sync',
    started: 'Syncing Shopify data…',
    completed: 'Shopify data updated',
    partial: 'Shopify data updated; some evidence is still being prepared',
    noData: 'Shopify customer data updated; no recent eligible purchases were found',
    failed: 'Shopify data sync failed',
};
//# sourceMappingURL=shopify-sync.js.map